// NextPageIcon.js
import React from 'react';

const NextPageIcon = ({ className, width = "24", height = "24" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    width={width}
    height={height}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7M2 5h2m0 0h2m-2 0V3m0 4v2m0 4v8m0-8h2m-2 0H2" />
  </svg>
);

export default NextPageIcon;
